import gameIds from '../../hub/data/GameIds';

export const GAME_ID = gameIds.PLANTORRES;

// screens
export const SCREENS = {
  PROGRESS: 'PLANTORRES_PROGRESS',
  STANDARD: 'PLANTORRES_STANDARD',
  LOADING: 'PLANTORRES_LOADING',
  FEEDBACK: 'PLANTORRES_FEEDBACK',
  ONBOARDING: 'PLANTORRES_ONBOARDING',
};

// Redux actions
export const REDUX_ACTIONS = {
  // game details actions
  UPDATE_GAME_PRACTICE_DETAILS: 'PLANTORRES_UPDATE_GAME_PRACTICE_DETAILS',
  UPDATE_GAME_ONBOARDING_DETAILS: 'PLANTORRES_UPDATE_GAME_ONBOARDING_DETAILS',
  RESET_GAME_TOPPERS_DETAILS_FOR_QUEST: 'PLANTORRES_RESET_GAME_TOPPERS_DETAILS_FOR_QUEST',
  // screen actions
  CHANGE_SCREEN: 'PLANTORRES_CHANGE_SCREEN',
  // curriculum actions
  LOAD_CURRICULUM: 'PLANTORRES_LOAD_CURRICULUM',
  SELECT_LEVEL: 'PLANTORRES_SELECT_LEVEL',
  // standard round actions
  INIT_STANDARD_ROUND: 'PLANTORRES_INIT_STANDARD_ROUND',
  NEXT_STANDARD_STEP: 'PLANTORRES_NEXT_STANDARD_STEP',
  DISCONTINUE_STANDARD_ROUND: 'PLANTORRES_DISCONTINUE_STANDARD_ROUND',
  BUILD_STANDARD_TOWER: 'PLANTORRES_BUILD_STANDARD_TOWER',
  MARK_PROGRESS: 'PLANTORRES_MARK_PROGRESS',
  QUICK_ROUND: 'PLANTORRES_QUICK_ROUND',
  // standard step actions
  INIT_STANDARD_STEP: 'PLANTORRES_INIT_STANDARD_STEP',
  SERVE_ADDER_ANSWER: 'PLANTORRES_SERVE_ADDER_ANSWER',
  SERVE_CHANGER_ANSWER: 'PLANTORRES_SERVE_CHANGER_ANSWER',
  SERVE_REMOVER_ANSWER: 'PLANTORRES_SERVE_REMOVER_ANSWER',
  COMPLETE_STEP: 'PLANTORRES_COMPLETE_STEP',
  // narration actions
  INIT_STANDARD_TIP_NARRATION: 'PLANTORRES_INIT_STANDARD_TIP_NARRATION',
  INIT_STANDARD_HINT_NARRATION: 'PLANTORRES_INIT_STANDARD_HINT_NARRATION',
  // game mode actions
  TURN_REWARD_MODE_ON: 'PLANTORRES_TURN_REWARD_MODE_ON',
  TURN_REWARD_MODE_OFF: 'PLANTORRES_TURN_REWARD_MODE_OFF',
  TURN_ONBOARDING_MODE_ON: 'PLANTORRES_TURN_ONBOARDING_MODE_ON',
  TURN_STANDARD_MODE_ON: 'PLANTORRES_TURN_STANDARD_MODE_ON',
  // onboarding round actions
  INIT_ONBOARDING_ROUND: 'PLANTORRES_INIT_ONBOARDING_ROUND',
  NEXT_ONBOARDING_STEP: 'PLANTORRES_NEXT_ONBOARDINGSTEP',
  BUILD_ONBOARDING_TOWER: 'PLANTORRES_BUILD_ONBOARDING_TOWER',
  // feedback actions
  INIT_FEEDBACK_ROUND: 'PLANTORRES_INIT_FEEDBACK_ROUND',
  SELECT_TOPPER: 'PLANTORRES_SELECT_TOPPER',
  UNLOCK_TOPPER: 'PLANTORRES_UNLOCK_TOPPER',

  // debug tools
  AUTO_COMPLETE_CORRECTLY: 'AUTO_COMPLETE_CORRECTLY',
  AUTO_COMPLETE_INCORRECTLY: 'AUTO_COMPLETE_INCORRECTLY',
};

// dropzone keys
export const DROPZONE_KEYS = {
  DROPZONE_LEFT: 'DROPZONE_LEFT',
  DROPZONE_RIGHT: 'DROPZONE_RIGHT',
};

export const REMOVE_DRAGGABLE_ID = 'remove';

export const INTERACTION_TYPES = {
  CHANGER: 'changer',
  ADDER: 'adder',
  REMOVER: 'remover',
};

// height of the part of the screen we should show dynamic background image is 426px (112 header + 314 top container)
// background image has 1902 height, 426px of it we show on the 1st step initially, so remaining is 1476px (1902-426)
export const STANDARD_BACKGROUND_ITERATIVE_HEIGHT = 1476;

// narration types
export const NARRATION_TYPES = {
  STANDARD_TIP: 'STANDARD_TIP',
  STANDARD_HINT: 'STANDARD_HINT',
};

// onboarding tip types
export const NARRATION_TIP_TYPES = {
  ONBOARDING_TIP_DRAG_THE_SYLLABLE: 1,
  STANDARD_TIP_CHANGE: 2,
  ONBOARDING_TIP_REMOVE: 3,
};

// narration hint types
export const NARRATION_HINT_TYPES = {
  LOOK_BEGINNING: 'lookBeginning',
  LOOK_MONOSYLLABLE: 'lookMonosyllable',
  LOOK_MIDDLE: 'lookMiddle',
  LOOK_ENDING: 'lookEnding',
  LOOK_MIDDLES: 'lookMiddles',
  CHANGE_SOUND: 'changeSound',
  CHANGE_SOUND_TO: 'changeSoundTo',
  CHANGE_ADD: 'changeAdd',
  CHANGE_BEGINNING: 'changeBeginning',
  CHANGE_MIDDLE: 'changeMiddle',
  CHANGE_MIDDLES: 'changeMiddles',
  CHANGE_ENDING: 'changeEnding',
  REMOVE_BEGINNING: 'removeBeginning',
  REMOVE_ENDING: 'removeEnding',
  REMOVE_SOUND: 'removeSound',
  ADD_SOUND: 'addSound',
  SOUND_BEGINNING: 'soundBeginning',
};

// amount of moves performed by user after which standard audio hint starts playing automatically
export const MOVES_AMOUNT_STANDARD_HINT_ON = 2;

// toppers
export const TOPPERS = {
  DEFAULT: 0,
  APPLE: 1,
  BEE: 2,
  FLOWERS: 3,
  FROG: 4,
  LADYBUG: 5,
  MUSHROOM: 6,
};

// topper types
export const TOPPER_TYPES = {
  CITY: 'CITY',
  BOX: 'BOX',
  TOWER: 'TOWER',
  REWARD: 'REWARD',
};

// topper sizes
export const TOPPER_SIZES = {
  [`${TOPPER_TYPES.CITY}`]: 125,
  [`${TOPPER_TYPES.BOX}`]: 250,
  [`${TOPPER_TYPES.TOWER}`]: 250,
  [`${TOPPER_TYPES.REWARD}`]: 350,
};

// colors map
export const COLORS_MAP = {
  RED: '#ea5348',
  ORANGE: '#eb7200',
  GREEN: '#5d9e0e',
  BLUE: '#007cd7',
  TEAL: '#1fa490',
  PURPLE: '#9c61d0',
  PINK: '#dd6aab',
};

// color names
export const COLOR_NAMES_INDEXED = [
  'RED',
  'ORANGE',
  'GREEN',
  'BLUE',
  'TEAL',
  'PURPLE',
  'PINK',
];

// colors by indexes
export const COLORS_INDEXED = [
  '#ea5348',
  '#eb7200',
  '#5d9e0e',
  '#007cd7',
  '#1fa490',
  '#9c61d0',
  '#dd6aab',
];

export const COLORS_COUNT = COLORS_INDEXED.length;

// feedback scenes
export const FEEDBACK_SCENES = {
  TOWER: 'TOWER',
  TOPPER_SELECTION: 'TOPPER_SELECTION',
  TOPPER_TOWER: 'TOPPER_TOWER',
  CITY: 'CITY',
};

// timeout, durations, etc
export const FEEDBACK_SCENE_CHANGE_TIMEOUT = 3000;
export const REWARD_FADE_ANIMATION_DURATION = 2000;
export const REWARD_ON_TOP_TIMEOUT = 3000;

// amount of towers displayed on the city district page
export const TOWERS_PER_CITY_DISTRICT = 6;

// amount of toppers (toppers places) displayed on toppers selection page for different modes
export const TOPPERS_LIST_LENGTH = {
  ONBOARDING: 1,
  STANDARD: 3,
};

// types of question
export const QUESTION_TYPES = {
  ONBOARDING: 'ONBOARDING',
  STANDARD: 'STANDARD',
};

// need those in order to recognize Alex voice narrations from other ones
// it may be better to have every of those as a separate const, but they are used only in narrations, so let it be in such way so far
export const ALEX_VOICE_NARRATION_SECTIONS = ['vo'];
export const MALE_VOICE_NARRATION_SECTIONS = ['words', 'phonemes'];

export const LECTURA_DOUBLE_LETTERS = ['ll', 'rr'];
